import * as React from "react";
import { forwardRef } from "react";
const CrownSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { d: "M13 6.734a2 2 0 1 0-2 0v1.268c0 1.5-1.009 4-3.504 4-2.245 0-2.913-1.487-3.354-3.358a2 2 0 1 0-1.95.187L5 20.999h14l2.808-12.166a2 2 0 1 0-1.948-.187c-.439 1.876-1.112 3.357-3.36 3.357-2.5 0-3.5-2.5-3.5-3.5z" }));
const ForwardRef = forwardRef(CrownSVG);
export default ForwardRef;
//# sourceMappingURL=Crown.js.map